export default "__VITE_ASSET__QCOFQPJB__"